module.exports = __webpack_public_path__ + "static/media/heatmap_texture.vertex.a0039a66.glsl";